export default __webpack_public_path__ + "static/media/smc.7dd8dbb1.png";